module.exports = __webpack_public_path__ + "img/certificate2-06.eff064d8.png";